import React from "react";
import "../css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing7">

      {/* ================= HERO ================= */}
      <section className="pr7-hero">
        <h1>Membership Plans</h1>
        <p>Train with intent. Choose a structure that fits your discipline.</p>
      </section>


      {/* ================= PLANS ================= */}
      <section className="pr7-plans">

        <div className="pr7-card">
          <h3>Foundation</h3>
          <h2>$49<span>/month</span></h2>

          <ul>
            <li>Unlimited gym access</li>
            <li>Strength & conditioning floor</li>
            <li>Basic progress tracking</li>
            <li>Open training hours</li>
          </ul>
        </div>

        <div className="pr7-card featured">
          <div className="tag">Most Chosen</div>
          <h3>Performance</h3>
          <h2>$89<span>/month</span></h2>

          <ul>
            <li>Everything in Foundation</li>
            <li>Group training sessions</li>
            <li>Structured strength cycles</li>
            <li>Mobility & recovery blocks</li>
            <li>Coach supervision</li>
          </ul>
        </div>

        <div className="pr7-card">
          <h3>Elite</h3>
          <h2>$149<span>/month</span></h2>

          <ul>
            <li>All Performance features</li>
            <li>1-on-1 personal coaching</li>
            <li>Custom weekly programming</li>
            <li>Advanced performance tracking</li>
            <li>Priority scheduling</li>
          </ul>
        </div>

      </section>


      {/* ================= VALUE STRIP ================= */}
      <section className="pr7-values">
        <div className="value-item">
          <strong>No Contracts</strong>
          <p>Train month-to-month without long-term lock-ins.</p>
        </div>

        <div className="value-item">
          <strong>Structured Progress</strong>
          <p>Programs designed around measurable results.</p>
        </div>

        <div className="value-item">
          <strong>Professional Coaching</strong>
          <p>Every plan is supported by experienced trainers.</p>
        </div>
      </section>


      {/* ================= COMPARISON ================= */}
      <section className="pr7-compare">
        <h2>Plan Comparison</h2>

        <div className="compare-grid">

          <div className="compare-row head">
            <span>Features</span>
            <span>Foundation</span>
            <span>Performance</span>
            <span>Elite</span>
          </div>

          <div className="compare-row">
            <span>Gym Access</span>
            <span>✔</span>
            <span>✔</span>
            <span>✔</span>
          </div>

          <div className="compare-row">
            <span>Group Training</span>
            <span>—</span>
            <span>✔</span>
            <span>✔</span>
          </div>

          <div className="compare-row">
            <span>Personal Coaching</span>
            <span>—</span>
            <span>—</span>
            <span>✔</span>
          </div>

          <div className="compare-row">
            <span>Custom Programming</span>
            <span>—</span>
            <span>—</span>
            <span>✔</span>
          </div>

          <div className="compare-row">
            <span>Recovery Sessions</span>
            <span>—</span>
            <span>✔</span>
            <span>✔</span>
          </div>

        </div>
      </section>


      {/* ================= CLOSING ================= */}
      <section className="pr7-end">
        <h2>Train With Purpose</h2>
        <p>
          Pricing reflects structure, coaching, and long-term performance —
          not shortcuts.
        </p>
      </section>

    </div>
  );
};

export default Pricing;
